import { useState } from 'react';

import { RouterProvider as TanstackRouterProvider } from '@tanstack/react-router';

import { router } from '@/lib/router';
import { LoadingPage } from '@/pages/loading';

import { useAuth } from './use-auth';

export const RouterProvider = () => {
  const authenticated = useAuth();
  const [isReady, setIsReady] = useState(false);

  // Until the first session check answers, the router would treat the user as logged out
  // and show the login page even with an active session, so wait on the loading page.
  // Only the first check, latched: a refetch, or a fresh query after queryClient.clear(), puts
  // the query back to pending, and unmounting the router then would loop or lose its state
  if (!isReady && authenticated.isFetched) {
    setIsReady(true);
  }
  if (!isReady && !authenticated.isFetched) {
    return <LoadingPage />;
  }

  return <TanstackRouterProvider router={router} context={{ authenticated: authenticated.data }} />;
};
